import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";

import {
  useEvent,
  useEventPlaces,
  useEventWriters,
  usePlace,
  useWriter,
} from "../../shared/data-access/calendar-data.provider";
import { Writer } from "../../shared/types/writer-type";
import {
  StyledContainer,
  StyledHeader,
  StyledImageContainer,
  StyledLabel,
  StyledQuoteText,
  StyledText,
} from "./description.style";
import { Place } from "../../shared/types/place-type";
import { Event } from "../../shared/types/event-type";
import { RichText } from "@graphcms/rich-text-react-renderer";

const Description = () => {
  const navigate = useNavigate();

  const { id, date } = useParams() as { id: string; date: string };
  const event: Event = useEvent(+id);

  const writer: Writer = useWriter(event?.writerIds[0]);
  const place: Place = usePlace(event?.placesIds[0]);

  if (writer) {
    return <DescriptionWriter writer={writer} />;
  }

  if (place) {
    return <DescriptionPlace place={place} />;
  }

  return <div>Страница не найдена</div>;
};

type DescriptionWriterProps = {
  writer: Writer;
};

const DescriptionWriter = ({ writer }: DescriptionWriterProps) => {
  const {
    imagePath,
    fullName,
    birthDate,
    deathDate,
    biography,
    quotes,
    activity,
  } = writer;

  const birthYear: number = dayjs(birthDate).year();
  const deathYear: number | string = deathDate
    ? dayjs(deathDate).year()
    : "н. в.";

  const biographyContent = biography && <RichText content={biography} />;

  const quotesContent =
    quotes &&
    quotes
      .split("\n")
      .map((quote, index) => (
        <StyledQuoteText key={index}>&laquo;{quote}&raquo;</StyledQuoteText>
      ));

  return (
    <StyledContainer>
      <StyledHeader>
        {imagePath && (
          <StyledImageContainer>
            <img src={`./assets/${imagePath}`} />
          </StyledImageContainer>
        )}
        <StyledLabel>
          <h1>{fullName}</h1>
          <h3>
            ({birthYear} &ndash; {deathYear})
          </h3>
          <h3>{activity}</h3>
        </StyledLabel>
      </StyledHeader>

      <StyledText>
        {biographyContent}

        {quotesContent}
      </StyledText>
    </StyledContainer>
  );
};

type DescriptionPlaceProps = {
  place: Place;
};

const DescriptionPlace = ({ place }: DescriptionPlaceProps) => {
  const { name, description } = place;

  return (
    <StyledContainer>
      <StyledHeader>
        <StyledLabel>
          <h1>{name}</h1>
        </StyledLabel>
      </StyledHeader>

      <StyledText>{description}</StyledText>
    </StyledContainer>
  );
};

export default Description;
